import { onViewChange } from '@/resources/assets/js/modules/utils';

class AlignMedia {

  constructor(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    this.root = node;
    this.imageContainer = this.root.querySelector('.AlignMedia-media');
    this.image = this.root.querySelector('img');

    if (window.innerWidth > 991) {
      this.#init();
    }
  }

  #init() {
    this.#resizeContainer();
    onViewChange(this.#resizeContainer.bind(this));
  }

  #resizeContainer() {
    const imageHeight = this.image.clientHeight;
    this.imageContainer.style.height = `${imageHeight}px`;
  }
}

[...document.querySelectorAll('.AlignMedia--breakout')].forEach(node => {
  new AlignMedia(node);
});